import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./ui";

export const PortreteTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="bg-[#0B0B0C] pb-24 sm:pb-36" data-testid="portrete-teaser">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center border-t border-[#C9A55C]/15 pt-24 sm:pt-32">
        <div className="lg:col-span-5 relative aspect-[4/5] overflow-hidden laser-frame">
          <motion.img style={{ y }} src="/img/laser-portrait.jpg" alt="Portret i gdhendur me lazer në granit të zi" className="absolute inset-0 w-full h-[120%] -top-[10%] object-cover" />
          <span className="laser-line" />
        </div>
        <Reveal className="lg:col-span-7">
          <Eyebrow>E re · Portrete me lazer</Eyebrow>
          <h2 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl text-[#F3EEE4] mt-6 leading-[1]">
            Fytyrat që doni, <em className="text-gold-grad">të gdhendura</em> në gur.
          </h2>
          <p className="mt-8 text-[#CFC8BA] text-base md:text-lg leading-relaxed max-w-xl">
            Nga një fotografi krijojmë portrete me lazer në mermer dhe granit: për përkujtimore, dhurata dhe dekor që zgjat brez pas brezi.
          </p>
          <Link to="/portrete" data-testid="portrete-teaser-link" className="btn-gold group mt-10 inline-flex items-center gap-3 rounded-full px-7 py-4 text-sm font-semibold tracking-wide">
            Zbuloni portretet <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
